<template>
  <div>
    <el-button
      type="danger"
      size="mini"
      plain
      @click.prevent="reboot"
    >
      Reboot
    </el-button>

    <el-dropdown @command="action">
      <el-button size="mini">
        Manage Server<i class="el-icon-arrow-down el-icon--right" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="increase">
          Increase Disk Size
        </el-dropdown-item>

        <el-dropdown-item command="resize">
          Change Server Type
        </el-dropdown-item>

        <el-dropdown-item command="upgrade">
          Upgrade Cloud services
        </el-dropdown-item>

        <el-dropdown-item command="transfer">
          Transfer to another project
        </el-dropdown-item>

        <el-dropdown-item class="terminate" command="terminate" divided>
          Terminate
        </el-dropdown-item>

        <el-dropdown-item
          v-if="permission('support')"
          class="show-logs"
          command="showLogs"
          divided
        >
          Show Server Logs
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  props: {
    plan: Object,
    instance: Object
  },
  computed: {
    ...mapState(['repositories', 'client']),
    ...mapGetters(['permission'])
  },
  methods: {
    action (command) {
      this[command]()
    },
    increase () {
      this.$router.push('/instances/' + this.instance.id + '/increase')
    },
    resize () {
      this.$router.push('/instances/' + this.instance.id + '/resize')
    },
    transfer () {
      this.$router.push('/instances/' + this.instance.id + '/transfer')
    },
    upgrade () {
      this.$confirm('Upgrade Cloud services will causes all apps to be down during few seconds. Continue?', 'Warning', {
        confirmButtonText: 'Upgrade Cloud Services',
        cancelButtonText: 'Cancel',
        confirmButtonClass: 'el-button--danger',
        type: 'warning'
      }).then(() => this.$store.dispatch('upgradeInstance', this.instance))
        .catch(() => {})
    },
    reboot () {
      this.$confirm('Hard rebooting the server will causes all apps to be down. Continue?', 'Warning', {
        confirmButtonText: 'Reboot Server',
        cancelButtonText: 'Cancel',
        confirmButtonClass: 'el-button--danger',
        type: 'warning'
      }).then(() => this.$store.dispatch('rebootInstance', this.instance))
        .catch(() => {})
    },
    terminate () {
      const msg = 'Once you terminate, there is no going back. To confirm, please enter TERMINATE below.'
      const repositories = this.repositories.filter((r) => r.instanceId === this.instance.id)

      if (repositories.length > 0) {
        return this.$confirm('There are ' + repositories.length + ' repositor' +
          (repositories.length === 1 ? 'y' : 'ies') + ' installed on this server, ' +
          'they will be deleted and the Git data will be lost. Continue?', 'Warning', {
          confirmButtonText: 'Yes continue',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => this.$prompt(msg, 'All applications will be lost !', {
          confirmButtonText: 'Terminate Server',
          cancelButtonText: 'Cancel',
          confirmButtonClass: 'el-button--danger',
          inputValidator: (value) => value === 'TERMINATE',
          inputErrorMessage: 'Invalid input'
        }).then(() => this.$store.dispatch('terminateInstance', this.instance))
          .catch(() => {}))
      }

      this.$prompt(msg, 'All applications will be lost !', {
        confirmButtonText: 'Terminate Server',
        cancelButtonText: 'Cancel',
        confirmButtonClass: 'el-button--danger',
        inputValidator: (value) => value === 'TERMINATE',
        inputErrorMessage: 'Invalid input'
      }).then(() => this.$store.dispatch('terminateInstance', this.instance))
        .catch(() => {})
    },
    showLogs () {
      this.$router.push('/instances/' + this.instance.id + '/support/logs')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../theme";

  .el-dropdown {
    margin-left: 10px;
  }
  .terminate {
    color: $--color-danger;
  }
  .show-logs {
    border-color: $--support-color-base;
    color: $--support-color-base !important;
  }
</style>
